import { Component, inject, OnInit, OnDestroy, ChangeDetectionStrategy, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PdksDurumService } from '@uygulamalar/hmi-pdks/services/pdks-durum.service';
import { HmiLookupService } from '@uygulamalar/hmi-pdks/pano/pages/personel/services/hmi-lookup.service';

@Component({
  selector: 'widget-personel-zeti',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="pz-kapsayici">
      <div class="pz-baslik">
        <span class="pz-ikon">👥</span>
        <span class="pz-baslik-metni">Personelzeti</span>
      </div>
      @if (personelSayisi() > 0) {
        <div class="pz-bolge">
          <div class="pz-bilgi">
            <span class="pz-etiket">Aktif personel</span>
            <span class="pz-deger">{{ personelSayisi() }}</span>
          </div>
          @if (pdks.aktifVardiya()) {
            <div class="pz-vadiya">
              <span class="pz-etiket">Vadiya</span>
              <span class="pz-deger">{{ pdks.aktifVardiya().vardiyaAdi }}</span>
            </div>
          } @else {
            <div class="pz-vadiya">
              <span class="pz-etiket">Vadiya</span>
              <span class="pz-deger">Tanımlı değil</span>
            </div>
          }
        </div>
      } @else {
        <div class="pz-boş">Personel tanımlı değil</div>
      }
    </div>
  `,
  styles: [`
    :host { display: block; }
    .pz-kapsayici {
      display: flex; flex-direction: column; gap: 14px; padding: 16px;
      height: 100%;
      background: linear-gradient(145deg, var(--py-kart, #fff), rgba(248,250,252,.92));
      border-radius: 16px;
    }
    .pz-baslik {
      display: flex; align-items: center; gap: 10px;
    }
    .pz-ikon {
      font-size: 1.4em;
    }
    .pz-baslik-metni {
      font-size: 1.1em; font-weight: 700;
      color: var(--py-metin, #172033);
    }
    .pz-bolge {
      display: flex; flex-direction: column; gap: 10px;
    }
    .pz-bilgi, .pz-vadiya {
      display: flex; justify-content: space-between; align-items: center;
      padding: 12px 14px; border-radius: 12px;
      background: rgba(100,116,139,.07);
    }
    .pz-etiket {
      font-size: .85em; font-weight: 600;
      color: var(--py-metin-ikincil, #8490a3);
    }
    .pz-deger {
      font-size: 1.1em; font-weight: 800;
      color: var(--py-metin, #172033);
      font-variant-numeric: tabular-nums;
    }
    .pz-boş {
      font-size: .85em; color: var(--py-metin-ikincil, #8490a3);
      font-style: italic;
    }
  `],
})
export class WidgetPersonelZetiComponent implements OnInit, OnDestroy {
  pdks = inject(PdksDurumService);
  lookup = inject(HmiLookupService);

  personelSayisi = signal(0);
  private _timer: any = null;

  ngOnInit() {
    this._personelYukle();
    this._timer = setInterval(() => {
      this.personelSayisi.set(this.lookup.personeller().length);
    }, 30000);
  }

  private _personelYukle() {
    this.lookup.personelleriYukle().then((liste) => this.personelSayisi.set(liste.length));
  }

  ngOnDestroy() {
    if (this._timer) clearInterval(this._timer);
  }
}
